import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import { clearAuthData } from '../../store/slices/authSlice';
import { logout } from '../../services/authService';
import { useTranslation } from '../../hooks/useTranslation';
import ConfirmationModal from '../ConfirmationModal';
import './Navbar.css';

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { username, userType } = useSelector((state: RootState) => state.auth);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    dispatch(clearAuthData());
    logout();
    setShowLogoutConfirm(false);
  };

  const isActive = (path: string) => location.pathname === path;

  const getUserTypeLabel = (type: string | null) => {
    switch (type) {
      case 'TWIZE_ADMIN': return t('userTypes.systemAdmin');
      case 'PARTNER_MANAGER': return t('userTypes.bankManager');
      case 'PARTNER_EMPLOYEE': return t('userTypes.bankEmployee');
      case 'CONSUMER': return t('userTypes.consumer');
      default: return t('userTypes.user');
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-brand">
          <h2 onClick={() => navigate('/dashboard')}>{t('nav.twizeGateway')}</h2>
        </div>
        
        <div className="navbar-links">
          <button 
            className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}
            onClick={() => navigate('/dashboard')}
          >
            {t('nav.dashboard')}
          </button>
          <button 
            className={`nav-link ${isActive('/system-users') ? 'active' : ''}`}
            onClick={() => navigate('/system-users')}
          >
            {t('nav.systemUsers')}
          </button>
          <button 
            className={`nav-link ${isActive('/consumers') ? 'active' : ''}`}
            onClick={() => navigate('/consumers')}
          >
            {t('nav.consumers')}
          </button>
          <button 
            className={`nav-link ${isActive('/debts') ? 'active' : ''}`}
            onClick={() => navigate('/debts')}
          >
            {t('nav.debts')}
          </button>
        </div>

        <div className="navbar-user">
          <div className="user-info">
            <span className="user-name">{username}</span>
            <span className="user-type">{getUserTypeLabel(userType)}</span>
          </div>
          <button className="logout-button" onClick={handleLogout}>
            {t('nav.logout')}
          </button>
        </div>
      </div>

      <ConfirmationModal
        isOpen={showLogoutConfirm}
        title={t('confirmation.confirmLogout')}
        message={t('confirmation.logoutMessage')}
        confirmText={t('confirmation.logout')}
        cancelText={t('confirmation.cancel')}
        onConfirm={confirmLogout}
        onCancel={() => setShowLogoutConfirm(false)}
        variant="info"
      />
    </nav>
  );
};

export default Navbar;

